import React from 'react';
import { ProtectedPage } from '../../layout/ProtectedPage';
import PenerimaDashboard from '../../componen/penerima/PenerimaDashboard';

export const PenerimaDashboardPages = () => <ProtectedPage><PenerimaDashboard /></ProtectedPage>;
